import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import {
  PermissionActionEnum,
  PermissionResourceEnum,
  PermissionSecondaryResourceEnum,
} from "../../../modules/shared/_enums/permission-resource.enum";
import { UserData } from "../../../_models/user.model";
import { AuthenticationService } from "../../../_services/authentication.service";
import { AccountService } from "@api/account";
import { Observable } from "rxjs";

@Component({
  selector: "app-left-navigation-xs",
  templateUrl: "./left-navigation-xs.component.html",
})
export class LeftNavigationXsComponent {
  public resource = PermissionResourceEnum;
  public subResource = PermissionSecondaryResourceEnum;
  public action = PermissionActionEnum;
  urlMarketplace: string;

  constructor(
    public router: Router,
    public authService: AuthenticationService,
    public accountService: AccountService
  ) {
    this.urlMarketplace = environment.marketplace;
  }

  get user$(): Observable<UserData> {
    return this.accountService.account$;
  }

  goToBlog() {
    // window.open(environment.marketplace_url + 'blog');
    window.open("https://xpath.zendesk.com/hc/en-us");
  }

  openMobileNav() {
    document.querySelector("body").classList.add("lock-scroll");
    document
      .querySelector(".mobile-navigation-wrapper")
      .classList.add("open-mobile-nav");
  }

  closeMobileNav() {
    document.querySelector("body").classList.remove("lock-scroll");
    document
      .querySelector(".mobile-navigation-wrapper")
      .classList.remove("open-mobile-nav");
  }
}
